import { fromJS } from 'immutable';
import { CHOOSE_PICK_ENERGY, END_PICKS, PICK_STEP, PICKS_CANCEL, START_PICKS, SUBMIT_PICKS } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  /** What the picks are for, while they're being made; see startPicks. */
  source: null,
  steps: [],
  /** The picks made so far, one per step. */
  picks: [],
  /** The Pokémon tapped whose energy cards are being picked now, as { from, at }. */
  choosing: null,
  submitting: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case START_PICKS:
      return initialState.merge({ source: action.payload.get('source'), steps: action.payload.get('steps') });

    case CHOOSE_PICK_ENERGY:
      return state.set('choosing', action.payload);

    case PICK_STEP:
      return state.update('picks', picks => picks.push(action.payload)).set('choosing', null);

    case SUBMIT_PICKS:
      return state.set('submitting', true);

    case PICKS_CANCEL:
    case END_PICKS:
    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
